<template>
  <span class="dynamic-list-toolbar-extensions">
    <component
      :is="ext.component"
      v-for="(ext, idx) in resolvedExtensions"
      :key="`list-toolbar-ext-${idx}`"
      :selected-item-ids="selectedItemIds"
      :model-name="modelName"
      :items="items"
      :is-trash-view="isTrashView"
      :is-archive-view="isArchiveView"
    />
  </span>
</template>

<script>
import {
  fetchActiveModulesForToolbar,
  getDynamicListToolbarExtensions,
  getRegisteredDynamicListToolbarExtensions,
} from "@/utils/dynamicListToolbarRegistry";

export default {
  name: "DynamicListSelectionToolbarExtensions",
  props: {
    selectedItemIds: {
      type: Array,
      default: () => [],
    },
    modelName: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    isTrashView: {
      type: Boolean,
      default: false,
    },
    isArchiveView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resolvedExtensions: [],
      loadSeq: 0,
    };
  },
  watch: {
    modelName: {
      immediate: true,
      handler() {
        this.loadExtensions();
      },
    },
    selectedItemIds: {
      handler(next) {
        if (Array.isArray(next) && next.length > 0) {
          this.loadExtensions();
        }
      },
    },
  },
  methods: {
    async loadExtensions() {
      const seq = ++this.loadSeq;
      let regs = getRegisteredDynamicListToolbarExtensions();
      if (regs.some((ext) => ext.requiresModule)) {
        const activeModules = await fetchActiveModulesForToolbar();
        if (seq !== this.loadSeq) return;
        regs = getDynamicListToolbarExtensions(activeModules);
      }
      if (regs.length === 0 && getRegisteredDynamicListToolbarExtensions().length > 0) {
        regs = getRegisteredDynamicListToolbarExtensions();
      }
      const resolved = [];
      for (const ext of regs) {
        try {
          let comp = ext.component;
          if (typeof comp === "function") {
            const mod = await comp();
            comp = mod.default || mod;
          }
          if (comp) {
            resolved.push({ ...ext, component: comp });
          }
        } catch (e) {
          console.error("[DynamicListToolbar] extension load failed:", e);
        }
      }
      if (seq !== this.loadSeq) return;
      this.resolvedExtensions = resolved;
    },
  },
};
</script>
